import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import config from 'lib/config';

const region = 'us-east-1';

const credentials = fromCognitoIdentityPool({
  identityPoolId: config.cognitioIdentityPoolId,
  accountId: '400329419115',
  clientConfig: { region },
});

export default credentials;
